/**
 * =====================================================================
 * CALENDARIO OFICIAL Y CONVOCATORIAS EXANI-II (CENEVAL) & UNINAV
 * =====================================================================
 * Fechas de convocatorias, registros y aplicaciones del examen EXANI-II
 * para las principales universidades del país y la Universidad Naval.
 * =====================================================================
 */

export const CALENDARIO_EXAMENES = [
  // ── 1. UNIVERSIDAD NAVAL (UNINAV - SEMAR) ──
  {
    id: 'uninav_2027',
    universidadId: 'UNINAV',
    institucion: 'Universidad Naval (UNINAV - SEMAR)',
    carreras: 'Médico Naval, Enfermería Naval, Ingenierías Navales',
    ciclo: 'Convocatoria Nacional 2027',
    periodo: 'Ciclo Escolar 2026-2027',
    fechaConvocatoria: 'Enero (2da quincena)',
    fechaRegistro: 'Enero – Marzo',
    fechaExamen: 'Abril – Mayo',
    faseDefinitiva: 'Junio – Julio (Heroica Escuela Naval)',
    resultados: 'Julio',
    estado: 'PROXIMA_CONVOCATORIA',
    estadoLabel: 'Convocatoria en Enero',
    estadoColor: '#c5a059',
    tipo: 'uninav',
    modalidad: 'Presencial / Sedes Regionales SEMAR',
    notas: 'Aplica examen EXANI-II (Fase Preliminar) con módulos específicos por carrera, seguido de pruebas médica, física y psicológica en Fase Definitiva.',
    enlaceOficial: 'https://www.uninav.edu.mx/uninav-semar/UNINAV/oferta.html'
  },

  // ── 2. SEGUNDA VUELTA / CONVOCATORIAS DE OTOÑO (INMEDIATAS) ──
  {
    id: 'ceneval_nacional_otono',
    universidadId: 'OTRA',
    institucion: 'Ceneval Institucional (Examen Desde Casa / Nacional)',
    carreras: 'Todas las áreas (Instituciones afiliadas)',
    ciclo: 'Aplicación Extraordinaria Otoño',
    periodo: 'Segundo Semestre',
    fechaConvocatoria: 'Agosto – Septiembre',
    fechaRegistro: 'Septiembre – Octubre',
    fechaExamen: 'Noviembre – Diciembre',
    faseDefinitiva: 'N/A',
    resultados: '20 días hábiles posteriores',
    estado: 'PROXIMO_EXAMEN',
    estadoLabel: 'Próximo Examen (Nov - Dic)',
    estadoColor: '#38bdf8',
    tipo: 'otono',
    modalidad: 'Examen Desde Casa / Computadora',
    notas: 'Fechas oficiales Ceneval para instituciones con ingresos semestrales intermedios (enero/febrero).',
    enlaceOficial: 'https://ceneval.edu.mx'
  },
  {
    id: 'uanl_segunda_vuelta',
    universidadId: 'UANL',
    institucion: 'Universidad Autónoma de Nuevo León (UANL)',
    carreras: 'Licenciaturas e Ingenierías (Plazas disponibles)',
    ciclo: 'Segunda Vuelta (Ingreso Enero)',
    periodo: 'Semestre Enero – Junio',
    fechaConvocatoria: 'Septiembre',
    fechaRegistro: 'Septiembre – Octubre',
    fechaExamen: 'Noviembre',
    faseDefinitiva: 'N/A',
    resultados: 'Diciembre',
    estado: 'PROXIMO_EXAMEN',
    estadoLabel: 'Próximo Examen (Noviembre)',
    estadoColor: '#38bdf8',
    tipo: 'otono',
    modalidad: 'Presencial / En Línea',
    notas: 'Concurso de ingreso para vacantes disponibles en facultades de la UANL.',
    enlaceOficial: 'https://www.uanl.mx/aspirantes/'
  },
  {
    id: 'uaemex_segunda_vuelta',
    universidadId: 'UAEMEX',
    institucion: 'Univ. Autónoma del Estado de México (UAEMéx)',
    carreras: 'Áreas seleccionadas con cupo remanente',
    ciclo: 'Segunda Convocatoria',
    periodo: 'Ciclo Intermedio',
    fechaConvocatoria: 'Agosto – Septiembre',
    fechaRegistro: 'Septiembre',
    fechaExamen: 'Octubre – Noviembre',
    faseDefinitiva: 'N/A',
    resultados: 'Noviembre',
    estado: 'PROXIMO_EXAMEN',
    estadoLabel: 'Próximo Examen (Oct - Nov)',
    estadoColor: '#38bdf8',
    tipo: 'otono',
    modalidad: 'Presencial en sedes UAEMéx',
    notas: 'Para aspirantes que desean iniciar clases en periodo semestral.',
    enlaceOficial: 'https://nuevoingreso.uaemex.mx'
  },

  // ── 3. CONVOCATORIAS GENERALES 2027 (UNIVERSIDADES AUTÓNOMAS) ──
  {
    id: 'uv_2027',
    universidadId: 'UV',
    institucion: 'Universidad Veracruzana (UV)',
    carreras: 'Todas las carreras (Xalapa, Veracruz, Orizaba, Poza Rica, Coatzacoalcos)',
    ciclo: 'Convocatoria General 2027',
    periodo: 'Ciclo Escolar 2026-2027',
    fechaConvocatoria: 'Febrero',
    fechaRegistro: 'Febrero – Marzo',
    fechaExamen: 'Mayo (fines de semana)',
    faseDefinitiva: 'N/A',
    resultados: 'Junio',
    estado: 'EN_PREPARACION',
    estadoLabel: 'Examen en Mayo',
    estadoColor: '#10b981',
    tipo: 'estatal',
    modalidad: 'Presencial / Examen Desde Casa',
    notas: 'Aplica EXANI-II de 168 reactivos (Áreas transversales + 2 módulos disciplinares específicos por carrera).',
    enlaceOficial: 'https://www.uv.mx/escolar/licenciatura2027'
  },
  {
    id: 'uady_2027',
    universidadId: 'UADY',
    institucion: 'Universidad Autónoma de Yucatán (UADY)',
    carreras: 'Medicina, Odontología, Ingenierías, Humanidades',
    ciclo: 'Proceso de Ingreso Licenciatura 2027',
    periodo: 'Ciclo Escolar 2026-2027',
    fechaConvocatoria: 'Febrero',
    fechaRegistro: 'Febrero – Marzo',
    fechaExamen: 'Mayo – Junio',
    faseDefinitiva: 'N/A',
    resultados: 'Junio',
    estado: 'EN_PREPARACION',
    estadoLabel: 'Examen en Mayo – Junio',
    estadoColor: '#10b981',
    tipo: 'estatal',
    modalidad: 'Presencial',
    notas: 'Alta demanda en Premedicina y Ciencias de la Salud con el nuevo modelo EXANI-II Ceneval.',
    enlaceOficial: 'https://ingreso.uady.mx'
  },
  {
    id: 'uanl_2027',
    universidadId: 'UANL',
    institucion: 'Universidad Autónoma de Nuevo León (UANL)',
    carreras: 'Todas las facultades (FIME, FACPYA, Medicina, etc.)',
    ciclo: 'Concurso de Ingreso 2027 (1ra Vuelta)',
    periodo: 'Ciclo Escolar 2026-2027',
    fechaConvocatoria: 'Marzo',
    fechaRegistro: 'Marzo – Mayo',
    fechaExamen: 'Junio (primer sábado)',
    faseDefinitiva: 'N/A',
    resultados: 'Junio (finales)',
    estado: 'EN_PREPARACION',
    estadoLabel: 'Examen en Junio',
    estadoColor: '#10b981',
    tipo: 'estatal',
    modalidad: 'Presencial / En Línea',
    notas: 'Examen Ceneval oficial obligatorio para todas las carreras profesionales de la UANL.',
    enlaceOficial: 'https://www.uanl.mx/aspirantes/'
  },
  {
    id: 'uaslp_2027',
    universidadId: 'UASLP',
    institucion: 'Universidad Autónoma de San Luis Potosí (UASLP)',
    carreras: 'Medicina, Enfermería, Hábitat, Derecho, Ingeniería',
    ciclo: 'Admisión Licenciatura 2027',
    periodo: 'Ciclo Escolar 2026-2027',
    fechaConvocatoria: 'Enero',
    fechaRegistro: 'Enero – Mayo',
    fechaExamen: 'Julio (primeros días)',
    faseDefinitiva: 'N/A',
    resultados: 'Julio',
    estado: 'EN_PREPARACION',
    estadoLabel: 'Examen en Julio',
    estadoColor: '#10b981',
    tipo: 'estatal',
    modalidad: 'Presencial en campus UASLP',
    notas: 'Combina examen psicométrico y examen EXANI-II de conocimientos según la facultad.',
    enlaceOficial: 'https://aspirantes.uaslp.mx'
  },
  {
    id: 'uaeh_2027',
    universidadId: 'UAEH',
    institucion: 'Universidad Autónoma del Estado de Hidalgo (UAEH)',
    carreras: 'ICSA, ICBI, ICEA, ICSHu, ESTl',
    ciclo: 'Convocatoria Julio – Diciembre 2027',
    periodo: 'Ciclo Escolar 2026-2027',
    fechaConvocatoria: 'Febrero',
    fechaRegistro: 'Febrero – Abril',
    fechaExamen: 'Mayo – Junio',
    faseDefinitiva: 'N/A',
    resultados: 'Junio',
    estado: 'EN_PREPARACION',
    estadoLabel: 'Examen en Mayo – Junio',
    estadoColor: '#10b981',
    tipo: 'estatal',
    modalidad: 'Presencial',
    notas: 'Aplicación estricta de EXANI-II en el Instituto de Ciencias de la Salud (Medicina/Enfermería).',
    enlaceOficial: 'https://www.uaeh.edu.mx/aspirantes/'
  },
  {
    id: 'uaa_2027',
    universidadId: 'UAA',
    institucion: 'Universidad Autónoma de Aguascalientes (UAA)',
    carreras: 'Todas las áreas académicas',
    ciclo: 'Admisión Pregrado 2027',
    periodo: 'Ciclo Escolar 2026-2027',
    fechaConvocatoria: 'Marzo',
    fechaRegistro: 'Marzo',
    fechaExamen: 'Mayo',
    faseDefinitiva: 'N/A',
    resultados: 'Junio',
    estado: 'EN_PREPARACION',
    estadoLabel: 'Examen en Mayo',
    estadoColor: '#10b981',
    tipo: 'estatal',
    modalidad: 'Presencial',
    notas: 'La UAA pondera el EXANI-II junto con el promedio de bachillerato.',
    enlaceOficial: 'https://www.uaa.mx'
  }
];

export const ETAPAS_RUTA_ASPIRANTE = [
  {
    etapa: '1',
    meses: 'Septiembre – Diciembre',
    titulo: 'Fase de Preparación y Diagnóstico (Momento Actual)',
    descripcion: 'Identificar fortalezas y debilidades con simuladores y flashcards. Dominar las áreas transversales (Pensamiento Matemático, Comprensión Lectora, Redacción) y estudiar los 2 módulos específicos de tu carrera.',
    activo: true,
    badge: '📍 Estamos aquí (Septiembre)'
  },
  {
    etapa: '2',
    meses: 'Noviembre – Diciembre',
    titulo: 'Exámenes de Otoño & Segunda Vuelta',
    descripcion: 'Aplicación para aspirantes a ciclo intermedio (enero) y examen de simulación general para aspirantes al ciclo 2027.',
    activo: false,
    badge: 'Próximo hito'
  },
  {
    etapa: '3',
    meses: 'Enero – Marzo',
    titulo: 'Publicación de Convocatorias y Registro en Línea',
    descripcion: 'SEMAR publica la convocatoria UNINAV (enero). Universidades estatales abren plataformas de prerregistro y entrega de fichas Ceneval.',
    activo: false,
    badge: 'Apertura Oficial'
  },
  {
    etapa: '4',
    meses: 'Abril – Junio',
    titulo: 'Aplicación Nacional de Exámenes EXANI-II',
    descripcion: 'Sedes presenciales y aplicaciones desde casa en todo el país. Examen de 168 reactivos y 4.5 horas de duración.',
    activo: false,
    badge: 'Día D'
  },
  {
    etapa: '5',
    meses: 'Junio – Julio',
    titulo: 'Resultados y Fase Definitiva',
    descripcion: 'Publicación de listas de aceptados. En UNINAV se realiza la Fase Definitiva (médica, física y psicológica) en Veracruz.',
    activo: false,
    badge: 'Admisión'
  }
];

